import z from 'zod';
import { createListApiSchema } from '../General/schemas';
import { siteSchema } from '../Site/schemas';
import { roleSchema } from '../Role/schemas';

export const zoneSchema = z
	.object({
		id: z.string(),
		name: z.string().optional(),
		description: z.string().optional(),
		siteId: z.string().length(4),
		externalId: z.string().optional(),
		isVirtual: z.boolean().optional(),
		isMusterZone: z.boolean().optional(),
		keywords: z.string().optional(),
		allowedRoles: z.array(z.lazy(() => roleSchema)).optional(), // virtual
		allowedEmergencyRoles: z.array(z.lazy(() => roleSchema)).optional(), // virtual
		site: z.lazy(() => siteSchema).optional(), // virtual
	})
	.describe('Zone');

export const zonesApiResponseSchema = createListApiSchema(zoneSchema).describe('ZoneList');
